import { combineReducers } from "redux";
import pollutantsReducer from "./pollutants";
import homeReducer from "./home.js";
import headerReducer from "./header.js";
import chemicalsReducer from "./chemicals";

export default combineReducers({
  home: homeReducer,
  header: headerReducer,
  pollutants: pollutantsReducer,
  chemicals: chemicalsReducer,
});
